module.exports = __webpack_public_path__ + "img/banner.6d00ae4e.jpg";